import { Controller } from "@hotwired/stimulus"
import { gsap } from "gsap"
import { SplitText } from "gsap/SplitText"
import { ScrollTrigger } from "gsap/ScrollTrigger"

export default class extends Controller {
	static targets = ["title", "content"]

	static values = {
		direction: {
			type: String,
			default: "horizontal"
		}
	}

	connect() {
		gsap.registerPlugin(SplitText)
		gsap.registerPlugin(ScrollTrigger)

		const split = SplitText.create(this.titleTarget, { type: "words" })
		gsap.from(split.words, {
			duration: 1,
			x: this.directionValue == "horizontal" ? -15 : null,
			y: this.directionValue == "vertical" ? 25 : null,
			autoAlpha: 0,
			stagger: 0.15,
			ease: "power4.out",
			delay: 0.25,
			scrollTrigger: {
				trigger: this.element,
				start: "top 50%"
			}
		})

		gsap.fromTo(
			this.contentTarget,
			{ opacity: 0 },
			{
				opacity: 1,
				duration: 2,
				delay: 0.75,
				scrollTrigger: {
					trigger: this.element,
					start: "top 50%"
				}
			}
		)
	}
}
